import React from 'react';

import {ResetLink, SelectContainer} from './styles';
import {FilterPopover} from 'features/dashboard/components/Filters/FilterPopover';

const Select = (props) => {
    const filter = props.filters[props.id];
    return (
        <FilterPopover label={props.children} closeOnClick={true}>
            {props.options.map((option) => {
                const value = option.value || option;
                const label = option.label || option;
                return (
                    <div
                        className={`filter text-xs ${filter === value ? 'active' : ''}`}
                        key={value}
                        onClick={() => props.updateFilters(props.id, value)}>
                        {label}
                    </div>
                );
            })}
        </FilterPopover>
    );
};

const ListFilters = (props) => {
    return (
            <SelectContainer>
                <Select {...props} id={'region_name'} options={props.regions}>
                    Region
                </Select>
                <Select
                    {...props}
                    id={'status'}
                    options={[
                        {value: 'active', label: 'Active'},
                        {value: 'auto-paused', label: 'Auto Paused'},
                        {value: 'user-canceled', label: 'User Canceled'},
                        {value: 'offer', label: 'Offer'},
                    ]}>
                    Status
                </Select>
                <ResetLink onClick={props.resetFilters}>Reset Filters</ResetLink>
            </SelectContainer>
    );
};

export default ListFilters;
